<template>
    <div>
        <b-button
            size="sm"
            @click="$_exportToExcel()"
            :disabled="!hasExportSelection"
        >
            <img
                src="~@/assets/icons/ng_fluent_downloadexcel_20_regular.svg"
                :alt="$t('downloadExcelFile')"
                :title="$t('downloadExcelFile')"
            />
        </b-button>
        <b-button
            size="sm"
            @click="$_exportToCSV()"
            :disabled="!hasExportSelection"
        >
            <img
                src="~@/assets/imported-icons/ic_fluent_arrow_download_20_regular.svg"
                :alt="$t('downloadCSVFile')"
                :title="$t('downloadCSVFile')"
            />
        </b-button>
    </div>
</template>

<script>
    import {
        exportToExcel,
        exportToCSV
    } from '../../../../services/utilities/export';

    export default {
        props: { exportData: { type: Array } },
        computed: {
            hasExportSelection: function () {
                return this.exportData?.length > 0 || false;
            }
        },
        methods: {
            $_exportToCSV() {
                const dataToExport = this.$_dataToExport();
                exportToCSV('export.csv', ';', dataToExport);
                this.$store.dispatch('trackUserEvent', {
                    name: 'export',
                    stage: 'csv'
                });
            },
            async $_exportToExcel() {
                const dataToExport = this.$_dataToExport();
                await exportToExcel('export.xlsx', dataToExport);
                this.$store.dispatch('trackUserEvent', {
                    name: 'export',
                    stage: 'excel'
                });
            },
            $_dataToExport() {
                const dataToExport = this.exportData;
                dataToExport.forEach(function (v) {
                    delete v._showDetails;
                });
                return dataToExport;
            }
        }
    };
</script>

<style lang="scss" scoped>
.btn {
    border: 1px solid transparent;

    &:disabled {
        color: $gray-04;
        background-color: transparent;
        border: 1px solid transparent;
    }
}
</style>
